const ngDrop = [ '$rootScope', '$modules', '$http', '$objects', function ($rootScope, $modules, $http, $objects) {

    return {
        /**
         * @param $scope
         * @param $item
         * @param $params {{ ngDrop: string, hover: void, json: string }}
         */
        link: function ( $scope, $item, $params ) {
            let $self = $item[0];
            // Push the new module
            $modules.add ( $params.ngDrop );

            // Json loaded
            let $loaded = false;
            // Last leave
            let $leave = false;

            let handler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
            // Handle click and touch
            $self.addEventListener(handler, function (event) {
                setTimeout(function () {
                    $modules.toggle($params.ngDrop);
                    if ( $params.ngDrop === 'mobileLeftSidebar') {
                        window.scrollTo({ top: 0 });
                    }
                    $scope.$apply();
                }, 200);
            }, { passive: true });

            // Handle mouse enter and leave
            if ( $params.hasOwnProperty('hover') === true ) {
                $self.addEventListener('mouseenter', function () {
                    console.log("drop - enter");
                    $leave = false;
                    if ( $params.hasOwnProperty('json') && $loaded === false ) {
                        $http.get($params.json).then(function (response) {
                            $objects.merge($scope.service, response.data.payload);

                            console.log("drop - http");
                            if ( $leave === false ) {
                                $modules.enter($params.ngDrop, function () {
                                    console.log("drop - apply");
                                    $scope.$apply();
                                });
                            } else {
                                setTimeout(() => {
                                    $scope.$apply()
                                }, 150 );
                            }
                        });
                        $loaded = true;
                    } else {
                        $modules.enter($params.ngDrop, function () {
                            $leave = false;
                            $scope.$apply();
                        });
                    }
                });

                $self.addEventListener('mouseleave', function () {
                    console.log("drop - leave");
                    $leave = true;
                    $modules.leave( function () {
                        $scope.$apply();
                    });
                });

            }

            // Begin the blur events
            if ( $params.hasOwnProperty('blur') === true ) {
                let blurs = function (event) {
                    if ($modules.visible($params.ngDrop) === true) {
                        let hide = true;
                        let node = event.target;

                        while (node) {
                            if (typeof node.attributes !== "undefined") {
                                if (node.getAttribute("ng-drop") === $params.ngDrop || node.getAttribute('ng-roll') === $params.ngDrop) {
                                    //   console.log("ARE Attr");
                                    hide = false;
                                    break;
                                }
                            }
                            if (node.parentNode) {
                                node = node.parentNode;
                            } else {
                                break;
                            }
                        }
                        if (hide === true) {
                            setTimeout(function () {
                                $modules.hide();
                                $scope.$apply();
                            }, 150 );
                            // console.log('hidden');
                        }
                    } else {
                        //console.log('no visible modules');
                    }
                };
                let handler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
                document.body.addEventListener(handler, blurs, { passive: true } );
            }
            // END the blur events

        }
    }
}];

export default ngDrop;
